<template>
    <div id="visitor-event-list">
        <a-spin :spinning="loading">
            <div v-if="events.length === 0" class="no-events">
                <div class="material-icons calendar-icon">calendar_today</div>
                <div class="title">{{ $t('message.noEventFound') }}</div>
            </div>
            <div class="events" v-for="eventDate in eventDates" :key="'evd-' + eventDate.start.split('T')[0]">
                <div class="date">{{ getDay(eventDate) }}</div>
                <div
                    class="event"
                    v-for="(event, index) in getDateEvents(eventDate)"
                    :key="event._id"
                    @click="getDetail(event._id)"
                >
                    <span class="divider-content">
                        <span :class="index > 0 ? 'divider' : ''" aria-hidden="true"></span>
                    </span>
                    <span class="event-content">
                        <span class="time">{{ getEventTime(event) }}</span>
                        <span class="infos">
                            <span class="info">
                                <AgentAvatar :size="30" :userID="event.userId" style="margin-right: 10px" />
                                <span class="detail">
                                    <span class="summary-title">{{ event.summary }}</span>
                                    <span class="description">{{
                                        !!event.description ? event.description : $t("auto.noContent")
                                    }}</span>
                                </span>
                            </span>
                            <span style="display: flex; flex-direction: row" v-if="event.refUsers.length > 0">
                                <span
                                    class="other-users"
                                    v-for="(refUser, refUserIndex) in event.refUsers"
                                    :key="refUser._id"
                                >
                                    <AgentAvatar
                                        :size="25"
                                        :userID="refUser._id"
                                        :class="refUserIndex === event.refUsers.length - 1 ? '' : 'img-setting'"
                                    />
                                </span>
                            </span>
                        </span>
                    </span>
                </div>
            </div>
            <CreateEventModal
                style="z-index: 999999 !important"
                :eventDetail="eventDetail"
                :calendarList="calendarList"
                v-if="newEventModalVisible"
                @close="newEventModalVisible = false"
                @deleteEvent="deleteEventFunction($event)"
                @editEvent="editEvent($event)"
            />
        </a-spin>
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import _ from "lodash";
import CreateEventModal from "../Calendar/Component/CreateEventModal.vue";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";

const log = log2("VisitorEventList");

export default {
    name: "VisitorEventList",
    components: { AgentAvatar, CreateEventModal },
    props: {
        visitorId: {
            type: String,
        },
        newEvent: {
            type: Object,
        },
    },
    data: () => {
        return {
            loading: false,
            events: [],
            eventDates: [],
            eventDetail: {},
            newEventModalVisible: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            calendarList: (state) => state.calendar.calendarList,
        }),
    },
    methods: {
        ...mapActions({
            getVisitorEvents: "calendar/getVisitorEvents",
            getEventDetail: "calendar/getEventDetail",
        }),
        getEventTime(event) {
            if (this.$i18n && this.$i18n.locale) {
                moment.locale(this.$i18n.locale);
            }
            return moment(event.start).format("HH:mm") + " - " + moment(event.end).format("HH:mm");
        },
        getDay(date) {
            if (this.$i18n && this.$i18n.locale) {
                moment.locale(this.$i18n.locale);
            }
            return moment(date.start).format("dddd, LL");
        },
        getDateEvents(date) {
            return this.events.filter((event) => event.start.split("T")[0] === date.start.split("T")[0]);
        },
        getDateFormat(date) {
            return moment(date).format("L LT");
        },
        isLastDate(item) {
            return moment().format() > moment(item.start.dateTime).format();
        },
        getDetail(id) {
            this.getEventDetail(id).then((detail) => {
                this.eventDetail = detail;
                this.newEventModalVisible = true;
            });
        },
        deleteEventFunction(event) {
            this.events = this.events.filter((item) => item._id !== event.eventId);
        },
        groupStartDate($event) {
            return $event.start.split("T")[0];
        },
        editEvent(event) {
            this.events = this.events.map((item) => {
                if (item._id === event.eventId) {
                    item.end = event.end;
                    item.start = event.start;
                    item.summary = event.summary;
                    item.description = event.description;
                }
                return item;
            });
        },
    },
    mounted() {
        this.loading = true;
        this.getVisitorEvents({ visitorId: this.visitorId, page: 1, pageSize: 5 }).then((res) => {
            this.loading = false;
            this.events = res;
            this.eventDates = _.uniqBy(res, (e) => this.groupStartDate(e));
        });
    },
    watch: {
        newEvent(val) {
            this.events = [val, ...this.events];
        },
    },
};
</script>

<style lang="scss">
#visitor-event-list {
    .other-users {
        display: flex;
        align-items: end;

        .img-setting {
            margin-right: -3px;
        }

        #avatar-placeholder {
            width: 25px !important;
            height: 25px !important;
        }
    }

    .events {
        border: 1px solid #d5d4d4;
        border-radius: 10px;
        padding: 20px;
        margin-top: 10px;
        background-color: white;

        .date {
            color: black;
            font-weight: 700;
            font-size: 16px;
            width: fit-content;
        }

        .event {
            display: flex;
            width: 100%;
            flex-direction: column;

            .event-content {
                display: flex;
                padding: 7px;

                &:hover {
                    background-color: #e3f2ff;
                    cursor: pointer;
                }
            }

            .time {
                margin-right: 10px;
                width: 100px;
            }

            .divider-content {
                width: 100%;
                display: flex;
                justify-content: end;

                .divider {
                    width: 80%;
                    border: 0.5px solid lightgrey;
                }
            }

            .infos {
                display: flex;
                justify-content: space-between;
                width: 100%;

                .info {
                    display: flex;

                    .image {
                        margin-right: 10px;
                    }

                    .detail {
                        display: flex;
                        flex-direction: column;

                        .summary-title {
                            font-size: 15px;
                            font-weight: 700;
                            color: black;
                        }
                    }

                    .description {
                    }
                }
            }
        }
    }

    .info {
        #avatar-placeholder {
            width: 30px !important;
            height: 30px !important;
        }
    }

    .no-events {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        .calendar-icon {
            font-size: 70px;
        }

        .title {
            font-weight: 500;
            font-size: 15px;
        }
    }

    .event-list {
        display: flex;
        margin-top: 10px;
        align-items: center;
        background-color: #f8f8f8;
        padding: 2px 10px;
        border-radius: 5px;
        cursor: pointer;

        .status {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            margin-right: 10px;

            &.last {
                background-color: red;
            }

            &.will {
                background-color: green;
            }
        }

        .info {
            margin-right: 10px;

            &.end {
                margin-left: 5px;
            }

            &.summary {
                font-weight: 500;
            }
        }
    }
}
</style>
